import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../design-system';

const CyclesIndexHeader = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col xs:flex-row flex-start gap-4 justify-between">
            <div>
                <h1 className="font-heading-bold text-heading-bold-l text-black">CRAFT Cycles</h1>
                <p className="font-body text-body-regular-xs text-neutral-300">
                    Collection of pre-designed goals with instructions configured to guide
                    interactions with AI.
                </p>
            </div>

            <div className="min-w-fit">
                <Button
                    type="secondary"
                    size="sm"
                    text="View Library"
                    onClick={() => navigate('/library/playbook')}
                />
            </div>
        </div>
    );
};

export default CyclesIndexHeader;
